import { GAME_CONNECTION_PROTOCOL_SUCCESS } from '@/Poker/data/Constants';
import { useSelector } from 'react-redux'

export default function useGameConnection(tempTableId) {
    const gameConnectionStatus = useSelector((state) => state.gameTable.games[tempTableId]?.gameConnectionStatus);

    if (!gameConnectionStatus) {
        return false
    }

    return {
        gameConnectionStatus: gameConnectionStatus,
        connected: gameConnectionStatus === GAME_CONNECTION_PROTOCOL_SUCCESS
    }
}
